const login = () => {
  return (
    <div>login page is under construction</div>
  )
}

export default login